var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.value)?_c('b-badge',{class:("rarity-bg-" + (_vm.data.value))},[_vm._v(" "+_vm._s(_vm.data.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }